import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {OAuthService} from "angular-oauth2-oidc";
import {environment} from "../../../../environments/environment";
import { Observable } from 'rxjs';
import { Profile } from 'src/app/models/ccm/profile.model';
import {Review, ReviewFilter} from 'src/app/models/ccm/review.model';
import {ClinicalNote} from "../../../models/ccm/clinical-note.model";
import { ReportFilter } from '../../../models/rpm/notification.model';
import { ChartsDataResponse } from '../../../models/vital-type.model';
import { SuperbillData, SuperbillRequest } from 'src/app/models/rpm/superbill.model';

@Injectable({
  providedIn: 'root'
})
export class ReviewsService {
  //private apiUrl = 'http://localhost:8081/v1';
  private apiUrl = environment.backEndUrl;

  constructor(
    private http: HttpClient,
    private oauthService: OAuthService
  ) {}

  getDataYM(id: string, year_month: string, offset: number, limit: number, sortParams: string = '') {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.oauthService.getAccessToken()
    });

    // TODO: map sort params into rigth params for the REST call

    return this.http.get(`${this.apiUrl}/available?id=${id}&offset=${offset}&limit=${limit}`, { headers });
  }

  getData(id: string, dataRange: string, offset: number, limit: number, filter: string = '', sortParams: string = '') {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.oauthService.getAccessToken()
    });

    // TODO: map sort params into rigth params for the REST call

    return this.http.get(
      `${this.apiUrl}/available?id=${id}&offset=${offset}&limit=${limit}&dateRange=${encodeURIComponent(dataRange)}` +
      (filter ? `&filter=${encodeURIComponent(filter)}` : ''),
      { headers }
    );

  }

  getObservations(ouid: string, pid: string, type: string, range: string ) {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.oauthService.getAccessToken()
    });

    return this.http.get(`${this.apiUrl}/obs?ouid=${ouid}&pid=${pid}&type=${type}&range=${range}`, { headers });
  }

  getClinicalNotes(sid: string) {
    return this.http.get(`${this.apiUrl}/cnotes?sid=${sid}`);
  }

  getBhiClinicalNotes(sid: string) {
    return this.http.get(`${this.apiUrl}/bhi-cnotes?sid=${sid}`);
  }

  getClinicalNotesByIds(sids: string[]): Observable<ClinicalNote[]> {
    return this.http.post<ClinicalNote[]>(`${this.apiUrl}/cnotes`, {sids: sids});
  }

  getBhiClinicalNotesByIds(sids: string[]): Observable<ClinicalNote[]> {
    return this.http.post<ClinicalNote[]>(`${this.apiUrl}/bhi-cnotes`, {sids: sids});
  }

  getEvents(sid: number) {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.oauthService.getAccessToken()
    });

    return this.http.get(`${this.apiUrl}/activity?sid=${sid}`, { headers });
  }

  getProfile(): Observable<Profile> {
    return this.http.get<Profile>(`${this.apiUrl}/profile`);
  }

  getReviews(reviewFilter: ReviewFilter): Observable<any> {
    return  this.http.post(`${this.apiUrl}/reviews`, reviewFilter);
  }

  getBhiReviews(reviewFilter: ReviewFilter): Observable<any> {
    return  this.http.post(`${this.apiUrl}/bhi-reviews`, reviewFilter);
  }

  getReport(reportFilter: ReportFilter){
    return  this.http.post(`${this.apiUrl}/reviews/kpi-reports`, reportFilter);
  }

  getReview(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/available/${id}`);
  }

  getBhiReview(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/bhi-available/${id}`);
  }

  getReviewReport(ids: string[]): Observable<Review[]>{
    return this.http.post<Review[]>(`${this.apiUrl}/available`, {ids: ids});
  }

  getBhiReviewReport(ids: string[]): Observable<Review[]>{
    return this.http.post<Review[]>(`${this.apiUrl}/bhi-available`, {ids: ids});
  }

  getVitalObservations(
    globalPatientId: string,
    vitalType: string,
    fromDate?: string,
    toDate?: string
  ): Observable<ChartsDataResponse> {
    let params = new HttpParams();
    if (fromDate) params = params.set('fromDate', fromDate);
    if (toDate) params = params.set('toDate', toDate);

    return this.http.get<ChartsDataResponse>(
      `${this.apiUrl}/vitals/${globalPatientId}/observations/${vitalType}`,
      { params }
    );
  }

  getSuperbill(request: SuperbillRequest): Observable<SuperbillData[]> {
    return this.http.post<SuperbillData[]>(this.apiUrl + '/superbill', request);
  }
}

